import { ObjectTypes } from '../api/object'
import { ButtonLink } from '../components/button'
import { Paper } from '../components/paper'
import { ObjectFormInPlace } from '../objects/object-form-in-place'
import { Activity } from '../widget/activity'
import { RelatedTable } from '../widget/related-table'
import { WidgetSum } from '../widget/sum'
import { PageLayout as PageLayoutT, Widget } from './types'

type Props<O extends keyof ObjectTypes> = {
	layout: PageLayoutT
	object: O
	id: string
	data?: ObjectTypes[O]
	children?: React.ReactNode
}

export function PageLayout<O extends keyof ObjectTypes>({
	layout,
	object,
	id,
	data,
	children,
}: Props<O>) {
	const renderWidget = (widget: Widget, index: number) => {
		switch (widget.type) {
			case 'formInPlace':
				return (
					<ObjectFormInPlace
						key={index}
						object={object}
						id={id}
						name={widget.name}
						style={widget.style}
					/>
				)
			case 'relatedFormInPlace':
				if (!data?.[widget.field]) return null
				return (
					<div key={index}>
						<div className="flex justify-between items-center gap-4 px-5 py-4 sm:px-6 sm:py-5">
							<h3 className="text-md font-bold">{widget.title}</h3>
							<ButtonLink
								variant="SECONDARY"
								size="SMALL"
								to={`/svc/${widget.object}/${data[widget.field]}`}
							>
								Detail
							</ButtonLink>
						</div>
						<ObjectFormInPlace
							object={widget.object}
							id={data[widget.field] as string}
							name={widget.name}
						/>
					</div>
				)
			case 'activity':
				return (
					<Activity
						key={index}
						object={object}
						id={id}
						action={widget.action}
						fields={widget.fields}
						style={widget.style}
					/>
				)
			case 'relatedTable':
				if (!data) return null
				return <RelatedTable key={index} parent={data} layout={widget.layout} />
			case 'widgetSum':
				return <WidgetSum key={index} id={id} />
			case 'paper':
				return (
					<Paper key={index}>
						<div className="grid gap-4">{widget.layout.widgets?.map(renderWidget)}</div>
					</Paper>
				)
			default:
				return null
		}
	}

	return (
		<div className="grid lg:grid-cols-2 gap-8 items-start">
			{layout.widgets?.map(renderWidget)}
			{children}
		</div>
	)
}
